module.exports = __webpack_public_path__ + "static/media/41-7.9386863d.mp3";